import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const messagesRoutes: Routes = [
  {
    path: 'messages',
    title: 'WEB_CONVERSATIONS_AAA',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/conversations.component').then(
        (m) => m.ConversationsComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.MESSAGES },
  },
];
